"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/slicedToArray"));

var _initializerDefineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/initializerDefineProperty"));

var _assertThisInitialized2 = _interopRequireDefault(require("@babel/runtime/helpers/assertThisInitialized"));

var _initializerWarningHelper2 = _interopRequireDefault(require("@babel/runtime/helpers/initializerWarningHelper"));

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));

var _applyDecoratedDescriptor2 = _interopRequireDefault(require("@babel/runtime/helpers/applyDecoratedDescriptor"));

var _react = _interopRequireWildcard(require("react"));

var _aphrodite = require("aphrodite");

var _mobxReact = require("mobx-react");

var _mobx = require("mobx");

var _lodash = _interopRequireDefault(require("lodash"));

var _jquery = _interopRequireDefault(require("jquery"));

var _StaggeredFadeIn = _interopRequireDefault(require("../effect/animation/StaggeredFadeIn"));

var _SquaredChevronButton = _interopRequireDefault(require("../button/SquaredChevronButton"));

var _Popover = _interopRequireDefault(require("../Popover"));

var _Icon = _interopRequireDefault(require("../Icon"));

var _styling = require("../../toolkit/styling");

var _providers = require("../../toolkit/providers");

var _dimen = require("../../toolkit/dimen");

var _class, _class2, _class3, _temp, _class4, _class5, _descriptor, _descriptor2, _descriptor3, _class6, _temp2;

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { (0, _defineProperty2["default"])(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = (0, _getPrototypeOf2["default"])(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = (0, _getPrototypeOf2["default"])(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return (0, _possibleConstructorReturn2["default"])(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

var TabButton = (0, _mobxReact.observer)(_class = (_class2 = (_temp = _class3 = /*#__PURE__*/function (_Component) {
  (0, _inherits2["default"])(TabButton, _Component);

  var _super = _createSuper(TabButton);

  function TabButton() {
    var _this;

    (0, _classCallCheck2["default"])(this, TabButton);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _super.call.apply(_super, [this].concat(args));
    _this.context = void 0;
    return _this;
  }

  (0, _createClass2["default"])(TabButton, [{
    key: "render",
    value: function render() {
      var _this$props = this.props,
          name = _this$props.name,
          icon = _this$props.icon,
          className = _this$props.className,
          style = _this$props.style;

      var iconDiv = icon && /*#__PURE__*/_react["default"].createElement(_Icon["default"], {
        name: icon,
        style: (0, _styling.css)(this.styles.icon)
      });

      return /*#__PURE__*/_react["default"].createElement("div", {
        className: (0, _styling.css)(this.styles.root, style, className)
      }, iconDiv, /*#__PURE__*/_react["default"].createElement("section", {
        className: (0, _styling.css)(this.styles.text)
      }, name));
    }
  }, {
    key: "styles",
    get: function get() {
      var _this$props2 = this.props,
          textPadding = _this$props2.textPadding,
          activeColor = _this$props2.activeColor,
          isSelected = _this$props2.isSelected;
      var _this$context$theming = this.context.theming,
          textBlack = _this$context$theming.theme.textBlack,
          fonts = _this$context$theming.fonts;
      return _aphrodite.StyleSheet.create({
        root: {
          flex: "1 1 auto",
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          overflow: "hidden"
        },
        icon: {
          height: 16,
          width: 16
        },
        text: {
          fontSize: 16,
          fontFamily: fonts.semibold,
          color: isSelected && activeColor ? activeColor : textBlack,
          padding: textPadding || "10px",
          textAlign: "center"
        }
      });
    }
  }]);
  return TabButton;
}(_react.Component), _class3.contextType = _providers.LegoContext, _temp), ((0, _applyDecoratedDescriptor2["default"])(_class2.prototype, "styles", [_mobx.computed], Object.getOwnPropertyDescriptor(_class2.prototype, "styles"), _class2.prototype)), _class2)) || _class;

var Pager = (0, _mobxReact.observer)(_class4 = (_class5 = (_temp2 = _class6 = /*#__PURE__*/function (_Component2) {
  (0, _inherits2["default"])(Pager, _Component2);

  var _super2 = _createSuper(Pager);

  function Pager() {
    var _this2;

    (0, _classCallCheck2["default"])(this, Pager);

    for (var _len2 = arguments.length, args = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
      args[_key2] = arguments[_key2];
    }

    _this2 = _super2.call.apply(_super2, [this].concat(args));
    _this2.context = void 0;
    (0, _initializerDefineProperty2["default"])(_this2, "currentIndexInternal", _descriptor, (0, _assertThisInitialized2["default"])(_this2));
    (0, _initializerDefineProperty2["default"])(_this2, "currentTabPage", _descriptor2, (0, _assertThisInitialized2["default"])(_this2));
    (0, _initializerDefineProperty2["default"])(_this2, "sliderWidth", _descriptor3, (0, _assertThisInitialized2["default"])(_this2));
    _this2.disposables = [];
    _this2.sliderRef = void 0;
    _this2.dimenTimeout = void 0;
    return _this2;
  }

  (0, _createClass2["default"])(Pager, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      var _this3 = this;

      if (this.sliderRef) {
        this.sliderWidth = 0.86 * this.sliderRef.clientWidth / this.maxVisibleTabs;
        this.dimenTimeout = setTimeout(function () {
          if (_this3.sliderRef) {
            _this3.sliderWidth = _this3.sliderRef.clientWidth / _this3.maxVisibleTabs;
          }
        }, 200);
      }

      this.disposables.push((0, _mobx.reaction)(function () {
        return [_this3.currentTabPage, _this3.maxVisibleTabs];
      }, function (_ref) {
        var _ref2 = (0, _slicedToArray2["default"])(_ref, 2),
            currentPage = _ref2[0],
            maxVisibleTabs = _ref2[1];

        if (_this3.sliderRef != null) {
          var sliderRef = _this3.sliderRef;
          var scrollToIndex = Math.max(currentPage * maxVisibleTabs - 1, 0);

          if (scrollToIndex >= sliderRef.childNodes.length) {
            return;
          }

          var scrollToLeft = Math.min(_this3.sliderWidth * scrollToIndex, sliderRef.scrollWidth - sliderRef.clientWidth); // Temporary lift on the jquery ban
          // eslint-disable-next-line jquery/no-animate

          (0, _jquery["default"])(sliderRef).animate({
            scrollLeft: scrollToLeft
          }, 300);
        }
      }));
      this.disposables.push((0, _mobx.reaction)(function () {
        return [_this3.currentIndex, _this3.maxVisibleTabs];
      }, function (_ref3) {
        var _ref4 = (0, _slicedToArray2["default"])(_ref3, 2),
            currentIndex = _ref4[0],
            maxVisibleTabs = _ref4[1];

        var targetPage = Math.floor(currentIndex / maxVisibleTabs);
        _this3.currentTabPage = targetPage;
      }));
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      if (this.dimenTimeout) {
        clearTimeout(this.dimenTimeout);
      }

      this.disposables.forEach(function (dispose) {
        return dispose();
      });
    }
  }, {
    key: "renderUnderline",
    value: function renderUnderline(idx) {
      if (idx != this.currentIndex) {
        return /*#__PURE__*/_react["default"].createElement("div", {
          className: (0, _styling.css)(this.styles.underlinePlaceholder)
        });
      }

      return /*#__PURE__*/_react["default"].createElement("div", {
        className: (0, _styling.css)(this.styles.underline)
      });
    }
  }, {
    key: "renderLeftButton",
    value: function renderLeftButton() {
      var _this4 = this;

      if (!this.canPageLeft) {
        return null;
      }

      return /*#__PURE__*/_react["default"].createElement(_StaggeredFadeIn["default"], {
        key: "left-button",
        className: (0, _styling.css)(this.styles.pagerButtonContainer),
        style: {
          left: 5,
          alignItems: "flex-start"
        },
        animationDurationMs: 200,
        deltaX: 7,
        deltaY: 0
      }, /*#__PURE__*/_react["default"].createElement(_SquaredChevronButton["default"], {
        direction: "left",
        onClick: function onClick() {
          return _this4.currentTabPage -= 1;
        },
        size: 10
      }));
    }
  }, {
    key: "renderRightButton",
    value: function renderRightButton() {
      var _this5 = this;

      if (!this.canPageRight) {
        return null;
      }

      return /*#__PURE__*/_react["default"].createElement(_StaggeredFadeIn["default"], {
        key: "right-button",
        className: (0, _styling.css)(this.styles.pagerButtonContainer),
        style: {
          right: 5,
          alignItems: "flex-end"
        },
        animationDurationMs: 200,
        deltaX: -7,
        deltaY: 0
      }, /*#__PURE__*/_react["default"].createElement(_SquaredChevronButton["default"], {
        direction: "right",
        onClick: function onClick() {
          return _this5.currentTabPage += 1;
        },
        size: 10
      }));
    }
  }, {
    key: "renderTab",
    value: function renderTab(_ref5, idx) {
      var _this6 = this;

      var titleValue = _ref5.titleValue,
          titleIcon = _ref5.titleIcon,
          disabled = _ref5.disabled,
          tabKey = _ref5.tabKey,
          popoverContent = _ref5.popoverContent;
      var _this$props3 = this.props,
          equalSizeTabs = _this$props3.equalSizeTabs,
          onTabChange = _this$props3.onTabChange,
          condenseMode = _this$props3.condenseMode,
          activeColor = _this$props3.activeColor,
          renderActiveLineAbove = _this$props3.renderActiveLineAbove;
      var isSelected = this.currentIndex === idx;
      var opacity = 0.5;

      if (isSelected) {
        opacity = 1;
      } else if (disabled) {
        opacity = 0.2;
      } else {
        opacity = 0.8;
      }

      var dimenStore = _dimen.DimenStore.instance();

      var defaultMinWidth = dimenStore.isSmallScreen ? 100 : 150;
      var minWidth = condenseMode ? "auto" : defaultMinWidth;
      return /*#__PURE__*/_react["default"].createElement("div", {
        key: tabKey,
        className: (0, _styling.css)(this.styles.tabItem, disabled ? this.styles.tabItemDisabled : this.styles.tabItemEnabled),
        style: {
          opacity: opacity
        },
        onClick: function onClick() {
          if (disabled) {
            return;
          }

          _this6.currentIndexInternal = idx;

          if (onTabChange) {
            onTabChange(tabKey);
          }
        }
      }, renderActiveLineAbove && this.renderUnderline(idx), typeof titleValue === "function" ? titleValue() : /*#__PURE__*/_react["default"].createElement(_Popover["default"], {
        position: "top",
        popoverContent: popoverContent,
        contentWidth: 200
      }, /*#__PURE__*/_react["default"].createElement(TabButton, {
        name: titleValue,
        icon: titleIcon,
        equalSizeTabs: equalSizeTabs,
        style: {
          minWidth: minWidth
        },
        textPadding: condenseMode ? 0 : 10,
        activeColor: activeColor,
        isSelected: isSelected
      })), !renderActiveLineAbove && this.renderUnderline(idx));
    }
  }, {
    key: "renderTabs",
    value: function renderTabs() {
      var _this7 = this;

      var tabsRowStyle = this.props.tabsRowStyle;

      if (!this.hasTabs) {
        return null;
      }

      return /*#__PURE__*/_react["default"].createElement("div", {
        className: (0, _styling.css)(this.styles.tabsRow, tabsRowStyle)
      }, this.renderLeftButton(), /*#__PURE__*/_react["default"].createElement("div", {
        className: (0, _styling.css)(this.styles.tabsRowContent),
        ref: function ref(_) {
          return _this7.sliderRef = _;
        }
      }, this.tabConfigs.map(function (tabConfig, idx) {
        return _this7.renderTab(tabConfig, idx);
      })), this.renderRightButton());
    }
  }, {
    key: "render",
    value: function render() {
      var className = this.props.className;
      return /*#__PURE__*/_react["default"].createElement("div", {
        className: (0, _styling.css)(this.styles.root, className)
      }, this.renderTabs(), /*#__PURE__*/_react["default"].createElement("div", {
        className: (0, _styling.css)(this.styles.content)
      }, this.currentContent));
    }
  }, {
    key: "currentIndex",
    get: function get() {
      var selectedTabKey = this.props.selectedTabKey,
          currentIndexInternal = this.currentIndexInternal;

      if (selectedTabKey !== undefined) {
        return _lodash["default"].findIndex(this.tabConfigs, {
          tabKey: selectedTabKey
        });
      }

      if (currentIndexInternal !== null) {
        return currentIndexInternal;
      }

      return 0;
    }
  }, {
    key: "pageCount",
    get: function get() {
      var maxVisibleTabs = this.maxVisibleTabs;
      return Math.ceil(this.tabConfigs.length / maxVisibleTabs);
    }
  }, {
    key: "maxVisibleTabs",
    get: function get() {
      var maxVisibleTabs = this.props.maxVisibleTabs;
      return maxVisibleTabs || 10;
    }
  }, {
    key: "canPageLeft",
    get: function get() {
      return this.currentTabPage > 0;
    }
  }, {
    key: "canPageRight",
    get: function get() {
      return this.currentTabPage < this.pageCount - 1;
    }
  }, {
    key: "children",
    get: function get() {
      var children = this.props.children;
      return _react["default"].Children.toArray(children).filter(function (_) {
        return !!_;
      });
    }
  }, {
    key: "tabConfigs",
    get: function get() {
      return this.children.map(function (child) {
        return child.props;
      }).filter(function (_) {
        return !!_.titleValue;
      });
    }
  }, {
    key: "currentContent",
    get: function get() {
      return this.children[this.currentIndex];
    }
  }, {
    key: "hasTabs",
    get: function get() {
      return this.tabConfigs.length > 0;
    }
  }, {
    key: "equalSizeTabs",
    get: function get() {
      var equalSizeTabs = this.props.equalSizeTabs;

      var dimenStore = _dimen.DimenStore.instance();

      return dimenStore.isSmallScreen || equalSizeTabs == true;
    }
  }, {
    key: "styles",
    get: function get() {
      var _this$context$theming2 = this.context.theming,
          _this$context$theming3 = _this$context$theming2.theme,
          primary = _this$context$theming3.primary,
          surfaceLightest = _this$context$theming3.surfaceLightest,
          borderPrimary = _this$context$theming3.borderPrimary,
          fonts = _this$context$theming2.fonts;
      var _this$props4 = this.props,
          contentAlignment = _this$props4.contentAlignment,
          tabAlignment = _this$props4.tabAlignment,
          condenseMode = _this$props4.condenseMode,
          _this$props4$activeCo = _this$props4.activeColor,
          activeColor = _this$props4$activeCo === void 0 ? primary : _this$props4$activeCo;
      var equalSizeTabs = this.equalSizeTabs,
          _this$props5 = this.props,
          tabsPadding = _this$props5.tabsPadding,
          hideHeaderBorder = _this$props5.hideHeaderBorder,
          hideTabBorder = _this$props5.hideTabBorder,
          tabItemHoverColor = _this$props5.tabItemHoverColor;
      var underlineKeyframes = {
        from: {
          transform: "scale3d(0, 1, 1)"
        },
        to: {
          transform: "scale3d(1, 1, 1)"
        }
      };
      var tabMargin = tabAlignment === "flex-end" ? {
        marginLeft: equalSizeTabs ? 0 : 24
      } : {
        marginRight: equalSizeTabs ? 0 : 24
      };
      return _aphrodite.StyleSheet.create({
        root: {
          display: "flex",
          flexDirection: "column",
          fontFamily: fonts.regular
        },
        tabItem: _objectSpread(_objectSpread({}, tabMargin), {}, {
          flexGrow: equalSizeTabs ? 1 : 0,
          flexBasis: equalSizeTabs ? 0 : "auto",
          display: "flex",
          flexDirection: "column",
          alignItems: "stretch",
          justifyContent: condenseMode ? "center" : "space-between",
          userSelect: "none"
        }),
        tabItemDisabled: {
          cursor: "default"
        },
        tabItemEnabled: {
          cursor: "pointer",
          transform: "translateZ(0)",
          transition: "opacity 0.4s linear, background-color 0.4s",
          ":hover": {
            opacity: 1,
            backgroundColor: tabItemHoverColor
          }
        },
        tabsRow: {
          display: "flex",
          flexDirection: "row",
          padding: tabsPadding,
          borderBottom: this.hasTabs && !hideHeaderBorder ? "solid 1px ".concat(borderPrimary) : undefined,
          backgroundColor: surfaceLightest,
          position: "relative"
        },
        tabsRowContent: {
          display: "flex",
          flex: 1,
          flexDirection: "row",
          overflowX: "hidden",
          justifyContent: tabAlignment ? tabAlignment : "flex-start"
        },
        content: {
          display: "flex",
          alignItems: contentAlignment ? contentAlignment : "stretch",
          flexDirection: "column"
        },
        underline: {
          height: condenseMode ? 2 : 4,
          backgroundColor: activeColor,
          borderRadius: equalSizeTabs ? 0 : 5,
          animationName: [underlineKeyframes],
          animationDuration: "150ms"
        },
        underlinePlaceholder: {
          borderBottom: !hideTabBorder ? "solid 1px ".concat(borderPrimary) : undefined,
          height: 4
        },
        pagerButtonContainer: {
          top: 0,
          bottom: 0,
          position: "absolute",
          display: "flex",
          flexDirection: "column",
          justifyContent: "center",
          zIndex: 1
        }
      });
    }
  }]);
  return Pager;
}(_react.Component), _class6.contextType = _providers.LegoContext, _class6.Content = function (props) {
  var titleValue = props.titleValue,
      disabled = props.disabled,
      tabKey = props.tabKey,
      otherProps = (0, _objectWithoutProperties2["default"])(props, ["titleValue", "disabled", "tabKey"]);
  return /*#__PURE__*/_react["default"].createElement("div", otherProps, props.children);
}, _class6.demoProps = {}, _class6.propDoc = {
  selectedTabKey: {
    required: false,
    type: "?number",
    defaultValue: "null",
    description: "Key of the currently displayed page/tab"
  },
  equalSizeTabs: {
    required: false,
    type: "boolean",
    defaultValue: "false",
    description: "Indicates that the tabs be equally sized"
  },
  tabsPadding: {
    required: false,
    type: "string",
    defaultValue: "0px",
    description: "Padding of the tabs row"
  },
  onTabChange: {
    required: false,
    type: "(tabKey: any) => mixed",
    defaultValue: "null",
    description: "Callback for when the user changes the tab"
  },
  maxVisibleTabs: {
    required: false,
    type: "number",
    defaultValue: "10",
    description: "Maxiumum number of tabs visible before scrolling"
  },
  hideHeaderBorder: {
    required: false,
    type: "boolean",
    defaultValue: "true",
    description: "Indicates that the border between the tabs " + "and the content should be hidden"
  },
  hideTabBorder: {
    required: false,
    type: "boolean",
    defaultValue: "false",
    description: "Indicates that the border under the tabs should be hidden"
  },
  condenseMode: {
    required: false,
    type: "boolean",
    defaultValue: "false",
    description: "Indicates to render smaller size pager"
  },
  tabsRowStyle: {
    required: false,
    type: "CSSProperties",
    defaultValue: "null",
    description: "Attach some custome styling to the tab row"
  },
  activeColor: {
    required: false,
    type: "string",
    defaultValue: _providers.DefaultThemingContext.theme.corePrimary,
    description: "Color of the underline that shows on the tab title"
  },
  tabItemHoverColor: {
    required: false,
    type: "string",
    defaultValue: "null",
    description: "Background color of tabs on hover"
  },
  renderActiveLineAbove: {
    required: false,
    type: "boolean",
    defaultValue: "false",
    description: "Render the active line at the top instead of the bottom of the selected tab"
  }
}, _class6.defaultProps = {
  equalSizeTabs: false,
  maxVisibleTabs: 10,
  hideHeaderBorder: true,
  hideTabBorder: true
}, _class6.demoRender = "\n<Pager>\n  <Pager.Content titleValue=\"milk\" titleIcon=\"star\">I'm the milk tab!</Pager.Content>\n  <Pager.Content titleValue=\"eggs\">I'm the eggs tab!</Pager.Content>\n  <Pager.Content titleValue=\"cheese\">I'm the cheese tab!</Pager.Content>\n  <Pager.Content titleValue=\"bread\" disabled>I'm the bread tab!</Pager.Content>\n</Pager>\n", _class6.demoWithVerticalLayout = true, _temp2), (_descriptor = (0, _applyDecoratedDescriptor2["default"])(_class5.prototype, "currentIndexInternal", [_mobx.observable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function initializer() {
    return 0;
  }
}), _descriptor2 = (0, _applyDecoratedDescriptor2["default"])(_class5.prototype, "currentTabPage", [_mobx.observable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function initializer() {
    return 0;
  }
}), _descriptor3 = (0, _applyDecoratedDescriptor2["default"])(_class5.prototype, "sliderWidth", [_mobx.observable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function initializer() {
    return 0;
  }
}), (0, _applyDecoratedDescriptor2["default"])(_class5.prototype, "currentIndex", [_mobx.computed], Object.getOwnPropertyDescriptor(_class5.prototype, "currentIndex"), _class5.prototype), (0, _applyDecoratedDescriptor2["default"])(_class5.prototype, "pageCount", [_mobx.computed], Object.getOwnPropertyDescriptor(_class5.prototype, "pageCount"), _class5.prototype), (0, _applyDecoratedDescriptor2["default"])(_class5.prototype, "maxVisibleTabs", [_mobx.computed], Object.getOwnPropertyDescriptor(_class5.prototype, "maxVisibleTabs"), _class5.prototype), (0, _applyDecoratedDescriptor2["default"])(_class5.prototype, "canPageLeft", [_mobx.computed], Object.getOwnPropertyDescriptor(_class5.prototype, "canPageLeft"), _class5.prototype), (0, _applyDecoratedDescriptor2["default"])(_class5.prototype, "canPageRight", [_mobx.computed], Object.getOwnPropertyDescriptor(_class5.prototype, "canPageRight"), _class5.prototype), (0, _applyDecoratedDescriptor2["default"])(_class5.prototype, "children", [_mobx.computed], Object.getOwnPropertyDescriptor(_class5.prototype, "children"), _class5.prototype), (0, _applyDecoratedDescriptor2["default"])(_class5.prototype, "tabConfigs", [_mobx.computed], Object.getOwnPropertyDescriptor(_class5.prototype, "tabConfigs"), _class5.prototype), (0, _applyDecoratedDescriptor2["default"])(_class5.prototype, "currentContent", [_mobx.computed], Object.getOwnPropertyDescriptor(_class5.prototype, "currentContent"), _class5.prototype), (0, _applyDecoratedDescriptor2["default"])(_class5.prototype, "hasTabs", [_mobx.computed], Object.getOwnPropertyDescriptor(_class5.prototype, "hasTabs"), _class5.prototype), (0, _applyDecoratedDescriptor2["default"])(_class5.prototype, "equalSizeTabs", [_mobx.computed], Object.getOwnPropertyDescriptor(_class5.prototype, "equalSizeTabs"), _class5.prototype), (0, _applyDecoratedDescriptor2["default"])(_class5.prototype, "styles", [_mobx.computed], Object.getOwnPropertyDescriptor(_class5.prototype, "styles"), _class5.prototype)), _class5)) || _class4;

var _default = Pager;
exports["default"] = _default;